const sleep_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"F[0].Page_1[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"F[0].Page_1[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":105,
      "radioGroup":"F[0].Page_1[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"F[0].Page_1[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   {
      "question":"Is continuous medication required for control of a sleep disorder condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2B"
      },
      "presidence":"Yes",
      "maxLength":175,
      "ref":0,
      "dbqName_yes":"F[0].#subform[1].Yes2B[0]",
      "dbqName_no":"F[0].#subform[1].No2B[0]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "List medications required for the veteran's sleep disorder",
      "textdbqName":"F[0].#subform[1].IfYes2C[0]",
      "textanswer":""
   },
   {
      "question":"Does ##name## require the use of a breathing assistance device such as a Continuous Positive Airway Pressure (CPAP) machine?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "MEDICAL HISTORY",
         number: "2C"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].#subform[1].Yes2C[0]",
      "dbqName_no":"F[0].#subform[1].No2C[0]",
      "answer":""
   },
   {
      "question":"Does ##name## currently have findings, signs or symptoms attributable to sleep apnea?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "2",
         title: "FINDINGS, SIGNS AND SYMPTOMS",
         number: "3"
      },
      "multi" : true,
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].#subform[1].Yes3[0]",
      "dbqName_no":"F[0].#subform[1].No3[0]",
      "answer":""
   },
   {
      "question":"Check all the signs or symptoms attributable to sleep apnea?",
      "redHeading":"",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "show": false,
      "refId":1,
      "section": {
         page: "2",
         title: "FINDINGS, SIGNS AND SYMPTOMS",
         number: "3"
      },
      "cols": 2,
      "small": true,
      "questions":[
         {
            "main":"Persistent daytime hypersomnolence",
            "dbqName":"F[0].#subform[1].A1[0]",
            "answer":""
         },
         {
            "main":"Cor pulmonale",
            "dbqName":"F[0].#subform[1].A6[0]",
            "answer":""
         },
         {
            "main":"Carbon dioxide retention",
            "dbqName":"F[0].#subform[1].A2[0]",
            "answer":""
         },
         {
            "main":"Requires tracheostomy",
            "dbqName":"F[0].#subform[1].A4[0]",
            "answer":""
         },
         {
            "main":"Chronic respiratory failure",
            "dbqName":"F[0].#subform[1].A3[0]",
            "answer":""
         },
         {
            "main":"Other",
            "dbqName":"F[0].#subform[1].A5[0]",
            "answer":"",
            "textarea": true,
            "maxLength":75,
            "textdbqName" : "F[0].#subform[1].Specify[1]",
            "placeholder": "describe signs and symptoms",
            "textAnswer": ""
         }       
      ],
      "answer":""
   },

   // Removed below question on the request of UAT team [dated: 02-17-2022]

   // {
   //    "question":"Has a sleep study been performed for the client in the past?",
   //    "sub":"",
   //    "type":"yesno",
   //    "show": true,
   //    "multi": true,
   //    "section": {
   //       page: "3",
   //       title: "DIAGNOSTIC TESTING",
   //       number: "5A"
   //    },
   //    "presidence":"Yes",
   //    "ref":0,
   //    "dbqName_yes":"F[0].Page_2[0].Yes5A[0],F[0].Page_2[0].Yes5A1[0]",
   //    "dbqName_no":"F[0].Page_2[0].No5A[0]",
   //    "answer":""
   // },
   // // {
   // //    "question":"Does ##name## have documented sleep disorder breathing?",
   // //    "sub":"",
   // //    "type":"radio",
   // //    "show": false,
   // //    "refId":1,
   // //    "section": {
   // //       page: "3",
   // //       title: "DIAGNOSTIC TESTING",
   // //       number: "5A"
   // //    },
   // //    "questions":[
   // //       {
   // //          "label":"Sleep Study",
   // //          "title":"",
   // //          "subMain":"",
   // //          "sub":"",
   // //          "options":[
   // //             {
   // //                "main":"Yes",
   // //                "dbqName":"F[0].Page_2[0].Yes5A1[0]",
   // //                "sub":""
   // //             },
   // //             {
   // //                "main":"No",
   // //                "dbqName":"F[0].Page_2[0].No5A1[0]",
   // //                "sub":""
   // //             }
   // //          ],
   // //          "answer":"No"
   // //       }
   // //    ]
   // // }, 
   // {
   //    "question":"Date of sleep study",
   //    "sub":"date format: [mm-dd-yyyy]",
   //    "type":"calendar",
   //    "concat":true, //concat month, date, year and fill single field
   //    "show": true,
   //    // "refId":2,
   //    "section": {
   //       page: "3",
   //       title: "DIAGNOSTIC TESTING",
   //       number: "5A"
   //    },
   //    "questions":[
   //       {
   //          "title":"Month",
   //          "month": true,
   //          "dbqName":"F[0].Page_2[0].Date[0]",
   //          "options":[
   //             {
   //                "values":[
   //                   "January",
   //                   "February",
   //                   "March",
   //                   "April",
   //                   "May",
   //                   "June",
   //                   "July",
   //                   "August",
   //                   "September",
   //                   "October",
   //                   "November",
   //                   "December"
   //                ],
   //                "answer":"January"
   //             },
   //          ]
   //       },
   //       {
   //          "title":"Day",
   //          "day": true,
   //          "dbqName":"F[0].Page_2[0].Date[0]",
   //          "options":[
   //             {
   //                "values":[
   //                   "31",
   //                   "30",
   //                   "29",
   //                   "28",
   //                   "27",
   //                   "26",
   //                   "25",
   //                   "24",
   //                   "23",
   //                   "22",
   //                   "21",
   //                   "20",
   //                   "19",
   //                   "18",
   //                   "17",
   //                   "16",
   //                   "15",
   //                   "14",
   //                   "13",
   //                   "12",
   //                   "11",
   //                   "10",
   //                   "9",
   //                   "8",
   //                   "7",
   //                   "6",
   //                   "5",
   //                   "4",
   //                   "3",
   //                   "2",
   //                   "1"
   //                ],
   //                "answer":"31"
   //             },
   //          ]
   //       }, 
   //       {
   //          "title":"Year",
   //          "year": true,
   //          "dbqName":"F[0].Page_2[0].Date[0]",
   //          "options":[
   //             {
   //                "values":[
   //                   "2023",
   //                   "2022",
   //                   "2021",
   //                   "2020",
   //                   "2019",
   //                   "2018",
   //                   "2017",
   //                   "2016",
   //                   "2015",
   //                   "2014",
   //                   "2013",
   //                   "2012",
   //                   "2011",
   //                   "2010",
   //                   "2009",
   //                   "2008",
   //                   "2007",
   //                   "2006",
   //                   "2005",
   //                   "2004",
   //                   "2003",
   //                   "2002",
   //                   "2001",
   //                   "2000",
   //                ],
   //                "answer":"2021"
   //             },
   //          ]
   //       },         
   //    ]
   // },
   // {
   //    "question":"Name of facility where sleep study performed",
   //    "sub":"",
   //    "type":"textarea",
   //    // "refId":3,
   //    "show": true,
   //    "section": {
   //       page: "3",
   //       title: "DIAGNOSTIC TESTING",
   //       number: "5A"
   //    },
   //    "placeholder": "Please specify the name of facility where sleep study performed",
   //    "dbqName":"F[0].Page_2[0].NAME[0]",
   //    "answer":""
   // },
   // {
   //    "question":"Results of facility where sleep study performed",
   //    "sub":"",
   //    "type":"textarea",
   //    // "refId":4,
   //    "show": true,
   //    "section": {
   //       page: "3",
   //       title: "DIAGNOSTIC TESTING",
   //       number: "5A"
   //    },
   //    "placeholder": "Please describe the Results of facility where sleep study performed",
   //    "dbqName":"F[0].Page_2[0].RESULTS[0]",
   //    "answer":""
   // },
   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "maxLength":1335,
      "type":"textarea",
      "show": true,
      "dbqName":"F[0].Page_2[0].REMARKSIfany[0]",
      "answer":""
   }
 ]

 export default sleep_questions ;
